export function getCirclePerimeter(radius) {
    return 2 * Math.PI * radius;
}

export function getArcLength(pct, radius) {
    return (100 - pct) / 10 +  (getCirclePerimeter(radius) / 100) * pct;
}
